<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For my esteemed friend Jon Bing in his Northern fastness</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?454d0054